<template>
  <div class="root">
    <div class="logo"></div>
    <el-menu
        default-active="0"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
      <el-menu-item index="0" :route="{ name: 'race' }">
        <el-icon><icon-menu /></el-icon>
        <span>竞赛管理</span>
      </el-menu-item>
      <el-menu-item index="1" :route="{ name: 'student_certificate' }">
        <el-icon><Document /></el-icon>
        <span>学生证书</span>
      </el-menu-item>
      <el-menu-item index="2" :route="{ name: 'teacher_certificate' }">
        <el-icon><Document /></el-icon>
        <span>教师证书</span>
      </el-menu-item>
      <el-menu-item index="3">
        <el-icon><Setting /></el-icon>
        <span>部门管理</span>
      </el-menu-item>
      <el-menu-item index="4">
        <el-icon><Setting /></el-icon>
        <span>比赛分类</span>
      </el-menu-item>
      <el-menu-item index="5" :route="{ name: 'student' }">
        <el-icon><User /></el-icon>
        <span>学生信息</span>
      </el-menu-item>
      <el-menu-item index="6" :route="{ name: 'statistics' }">
        <el-icon><TrendCharts /></el-icon>
        <span>数据统计</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script setup>
import {
  Menu as IconMenu,
  Document,
  Setting,
  User,
  TrendCharts,
} from '@element-plus/icons-vue'
import router from "@/router"

const handleSelect = (index) => {
  if (index === '0') {
    router.push({ name: 'race' });
  } else if (index === '1') {
    router.push({ name: 'student_certificate' });
  } else if (index === '2') {
    router.push({ name: 'teacher_certificate' });
  } else if (index === '3') {
    router.push({ name: 'department' })
  } else if (index === '4') {
    router.push({ name: 'category' })
  } else if (index === '5') {
    router.push({ name: 'student' })
  } else if (index === '6') {
    router.push({ name: 'statistics' })
  }
}
</script>

<style scoped>
.root {
  width: 100%;
  height: 100%;
  background-color: #545c64;
}

div.logo {
  height: calc(15vw * 0.417);
  width: 15vw;
  background: url('../../public/logo2.png');
  background-size: cover;
}

.el-icon {
  margin-left: -23px;
}

.el-menu-item {
  justify-content: center;
}
</style>
